import config, { WebsitePaths } from "config/config";
import { Locale } from "contexts/LocaleContext/locales";

const { websiteUrl } = config;

type Path = keyof WebsitePaths;

const websiteUrls = (path: Path, locale: Locale) => {
  const pathForLocale = config.websitePaths[path][locale];
  const fallbackPath = config.websitePaths[path]["en"];

  return pathForLocale ? `${websiteUrl}/${locale}/${pathForLocale}/` : `${websiteUrl}/en/${fallbackPath}/`;
};

const websiteAhPlusLandingPage = (hash: string, locale: Locale = "en") => {
  return hash ? `${websiteUrl}/${locale}/airhelp-plus/#${hash}` : `${websiteUrl}/${locale}/airhelp-plus/`;
};

export { websiteUrls, websiteAhPlusLandingPage };
